// Copyright 2018-2023 contributors to the Marquez project
// SPDX-License-Identifier: Apache-2.0

import { AppBar, Toolbar } from '@mui/material'
import { DRAWER_WIDTH } from '../../helpers/theme'
import { createTheme } from '@mui/material/styles'
import { useTheme } from '@emotion/react'
import Box from '@mui/material/Box'
import React, { ReactElement } from 'react'
import Search from '../search/Search'
import { useSelector } from 'react-redux'
import { IState } from '../../store/reducers'
import { iframeDarkColor, iframeLightColor, borderWhite } from '../../helpers/theme'

const Header = (): ReactElement => {
  const theme = createTheme(useTheme())
  const { isIframe, theme: iframeTheme, locale } = useSelector((state: IState) => state.iframe)

  return (
    <AppBar
      position='fixed'
      elevation={0}
      sx={{
        zIndex: theme.zIndex.drawer + 1,
        backgroundColor: iframeTheme === 'dark' ? iframeDarkColor : iframeLightColor,
        borderBottom: `2px dashed ${iframeTheme === 'dark' ? theme.palette.secondary.main : borderWhite}`,
        left: isIframe ? '0' : `${DRAWER_WIDTH + 1}px`,
      }}
    >
      <Toolbar disableGutters>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            width: 'calc(100% - 97px)',
          }}
        >
          <Box display={'flex'} alignItems={'center'}>
            <Search key={locale} />
          </Box>
        </Box>
      </Toolbar>
    </AppBar>
  )
}

export default Header
